module.exports = __webpack_public_path__ + "img/bg32.b0d42959.png";